import { Injectable, OnDestroy, inject } from '@angular/core';
import { UserInformation } from './user-information';
import { BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../route/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserInformationService implements OnDestroy {
  private authService = inject(AuthService);
  private oAuthService = inject(OAuthService);


  private subscription: Subscription;

  public userInformation!: UserInformation;
  private canChangePasswordSubject$ = new BehaviorSubject<boolean>(false);
  public canChangePassword$ = this.canChangePasswordSubject$.asObservable();

  constructor() {
    this.subscription = this.authService.isAuthenticated$.pipe(
      tap(
        isAuthenticatd => {
          if (isAuthenticatd) {
            const userInfos: any = this.oAuthService.getIdentityClaims();
            this.userInformation = new UserInformation(
              userInfos.user_id,
              userInfos.user_name,
              userInfos.user_department
            );
            console.log(`userinfo canChangePassword ${userInfos.can_change_password}`);
            this.canChangePasswordSubject$.next(userInfos.can_change_password);
          }
          else {
            console.log(`userinfo canChangePassword = false`);
            this.userInformation = new UserInformation('','','');
            this.canChangePasswordSubject$.next(false);
          }
        }
      )
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
